import { Vector2Tuple, Vector3 } from 'three';

import { isPointInNavMesh, NavMeshQuery } from '@spazious/dollhouse-navmesh';

import getOrientedBox2Corners from './getOrientedBox2Corners.js';

const _target = new Vector3();
export const rotateBoxInNavMesh = (
  center: Vector2Tuple,
  size: Vector2Tuple,
  theta: number,
  targetTheta: number,
  navMeshQuery: NavMeshQuery
): number => {
  const stepSize = (targetTheta > theta ? -1 : 1) * ((1 * Math.PI) / 180); // 1 degree to radians
  let selectedAngle = theta;
  for (
    let angle = targetTheta;
    targetTheta > theta ? angle > theta : angle < theta;
    angle += stepSize
  ) {
    let targetCorners = getOrientedBox2Corners(center, size, angle);

    const success = targetCorners.every((corner) => {
      _target.set(corner[0], 0, corner[1]);
      return isPointInNavMesh(_target, navMeshQuery);
    });
    if (success) {
      selectedAngle = angle;
      break;
    }
  }

  return selectedAngle;
};
